module.exports = __webpack_public_path__ + "img/Stortingsmelding-nr.-31_Ikkje-røyk-her-skilt.b189a580.jpg";